import React from 'react'
import {Image} from 'react-konva'
import {handle, raise} from '../events'
import meteorGraphic from './asteroid_main.png'
import {sprite} from '../system/sprite'
import {getDirection, lerp, register} from '../utils'

import useImage from 'use-image'
import {addGameObject} from '../system'
import {getState} from '../game-surface'
import {explode, explosionSound} from '../explosion'
import {playSound} from '../sound'

function Sprite(sprite) {
    return function Sprite() {
        let [image] = useImage(sprite)
        return (
            (image && (
                <Image
                    x={-image.width / 2}
                    y={-image.height / 2}
                    image={image}
                />
            )) ||
            null
        )
    }
}

const meteor = register('meteor', {
    initialize() {
        this.$.y = -2000
        handle('resetGame', () => {
            this.$.setState('default')
        })
    },
    states: {
        default: {
            enter() {
                this.$.visible = false
                this.$.y = -200000
                this.$.scale = 1
                this.$.target = null
                this.$.speed = 0
                if (this.$.movement) {

                    this.$.movement.x = 0
                    this.$.movement.y = 0
                }
                let state = getState()
                state.meteors = state.meteors || []
                !state.meteors.includes(this.$) && state.meteors.push(this.$)
            },
        },
        go: {
            enter() {
                this.$.visible = true
                this.$.y = -700
                this.$.x = Math.random() * 2300 - 500
                this.$.speed = Math.random() * 500 + 1000
                this.$.movement.rotation = Math.random() * 460
                this.scale = (Math.random() * 0.7 + 0.4) * 4
                this.targetScale = Math.random() * 0.4 + 0.1
                this.distance = getDirection(
                    this.$.position(),
                    this.$.target.position()
                ).l
                let direction = getDirection(
                    this.$.target.position(),
                    this.$.position(),
                    this.$.speed
                )
                this.$.movement.x = direction.x
                this.$.movement.y = direction.y
            },
            methods: {
                update(dt) {
                    let {l} = getDirection(
                        this.$.position(),
                        this.$.target.position()
                    )

                    this.$.scale = lerp(
                        this.targetScale,
                        this.scale,
                        l / this.distance
                    )
                    if (l < 50) {
                        playSound(explosionSound)
                        explode(this.$.target.position())
                        this.$.target.setState('falling')
                        this.$.setState('default')
                    }
                },
            },
        },
    },
})

export function fireMeteor() {
    const {meteors = [], rocket} = getState()
    if (!meteors.length) return
    if (getState().gameOver) return
    if (rocket.parts.every(p => p.behaviours.state === 'waiting')) {
        let targets = rocket.parts.slice(0)
        let meteor
        do {
            meteor = meteors.pop()
            if (meteor) {
                let target =
                    targets[
                    Math.floor(Math.random() * targets.length) %
                    targets.length
                        ]
                targets.splice(targets.findIndex(f => f === target), 1)
                if (target) {
                    meteor.target = target
                    meteor.setState('go')
                }

            }
        } while (meteor)
        raise('gameOver')
        getState().gameOver = true
        return
    }
    let availableTargets = rocket.parts.filter((part) => {
        const [{ok}] = part.api.canHit({ok: false})
        return ok && part.targetted <= 0
    })
    let target =
        availableTargets[
        Math.floor(Math.random() * availableTargets.length) %
        availableTargets.length
            ]
    if (target) {
        target.targetted = 7000
        let meteor = meteors.pop()
        meteor.target = target
        meteor.setState('go')
    }
}

handle('initializeGame', () => {
    for (let i = 0; i < 10; i++) {
        addGameObject(
            {z: 600},
            {
                meteor,
                ...sprite.config({Sprite: Sprite(meteorGraphic)}),
                moving: {vector: {y: 100, x: 100}},
            }
        )
    }
})
